/**
 * DatepickerCardDe — German variant of DatepickerCard.
 *
 * Heyflow widget tag:
 *   <div data-conny-widget="datepicker-card-de"></div>
 *
 * Writes to sessionStorage:
 *   conny_move_in_date  — "YYYY-MM-DD" once the user has entered a valid date
 */
import { useState } from "react";
import { setBlockValue } from "../../shared/heyflow-bridge";
import { STORAGE_KEYS, useStorage } from "../../shared/storage";

const HEYFLOW_VARIABLE = "conny_movein_date";

export function DatepickerCardDe() {
  const [stored, setStored] = useStorage(STORAGE_KEYS.moveInDate);
  const [display, setDisplay] = useState(() => {
    if (/^\d{4}-\d{2}-\d{2}$/.test(stored)) {
      const [yyyy, mm] = stored.split("-");
      return `${mm}/${yyyy}`;
    }
    return stored;
  });
  const [error, setError] = useState("");

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 6);

    let formatted = digits.slice(0, 2);
    if (digits.length > 2) formatted += "/" + digits.slice(2);

    setDisplay(formatted);

    if (formatted.length === 7) {
      const month = parseInt(digits.slice(0, 2), 10);
      if (month < 1 || month > 12) {
        setError("Bitte geben Sie einen gültigen Monat ein (01–12).");
      } else {
        setError("");
        const mm = digits.slice(0, 2);
        const yyyy = digits.slice(2);
        const isoDate = `${yyyy}-${mm}-01`;
        setStored(isoDate);
        setBlockValue(HEYFLOW_VARIABLE, isoDate);
      }
    } else {
      setError("");
      if (stored) setStored("");
    }
  }

  return (
    <div className="cn">
      <input
        type="text"
        inputMode="numeric"
        placeholder="MM/JJJJ"
        value={display}
        onChange={handleChange}
        maxLength={7}
        className="cn-datepicker-input"
        aria-label="Einzugsdatum (MM/JJJJ)"
      />
      {error && <p className="cn-datepicker-error">{error}</p>}
    </div>
  );
}
